/// <amd-module name="Wit/UI/IdentityConstants" />
export const Identity_UnassignedUserIcon = "ms.vss-work-web/wit-ui-identity/Content/notassigned-user.svg";
